import React from 'react'
import {CreateGuesser} from '@api-platform/admin'
import {TextInput, NumberInput, TextField, AutocompleteInput, ReferenceInput} from 'react-admin';
import {useTranslation} from "react-i18next";


function Create(props) {
    const {t} = useTranslation()

    return (
        <CreateGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <TextInput source="code" label={t('admin.code')}/>
            <NumberInput source="foreignId" label={'foreignId'}/>
            <ReferenceInput
                source="media"
                reference="dictionary/medias"
                label={t('admin.media')}
            >
                <AutocompleteInput optionText="name"/>
            </ReferenceInput>
        </CreateGuesser>
    )
}

export default Create
